import { MessageIcon } from '@src/components/icons/MessageIcon';
import { PlusIcon } from '@src/components/icons/PlusIcon';
import { PencilIcon } from '@src/components/icons/PencilIcon';
import { IdCardIcon } from '@src/components/icons/IdCardIcon';
import { LinkIcon } from '@src/components/icons/LinkIcon';
import { MailIcon } from '@src/components/icons/MailIcon';
import { EyeIcon } from '@src/components/icons/EyeIcon';
import { GiftIcon } from '@src/components/icons/GiftIcon';
import { RefreshIcon } from '@src/components/icons/RefreshIcon';
import { BoxIcon } from '@src/components/icons/BoxIcon';
import { PackageIcon } from '@src/components/icons/PackageIcon';
import { TrashIcon } from '@src/components/icons/TrashIcon';
import { ClockIcon } from '@src/components/icons/ClockIcon';
import { SettingsIcon } from '@src/components/icons/SettingsIcon';
import { ThemeIcon } from '@src/theme/ThemeIcon';

export function ActivityEventIcon({ type }: { type: string }) {
  if (type === 'box.settings_updated' || type === 'box.exclusions_updated') {
    return <ThemeIcon name="nav-settings" fallback={<SettingsIcon />} />;
  }
  const icons = {
    'participant.left': TrashIcon, 'participant.removed': TrashIcon, 'participant.giftee_changed': RefreshIcon,
    'box.premium_address_requested': LinkIcon,
    'question.updated': PencilIcon,
    'organizer.name_changed': PencilIcon,
    'message.sent': MessageIcon, 'participant.added': PlusIcon, 'participant.joined': PlusIcon,
    'participant.card_updated': PencilIcon, 'participant.card_claimed': IdCardIcon,
    'participant.giftee_revealed': EyeIcon, 'invitation.link_copied': LinkIcon,
    'invitation.email_queued': MailIcon, 'box.created': GiftIcon,
    'box.draw_updated': RefreshIcon,
    'box.draw_completed': GiftIcon, 'box.draw_reset': RefreshIcon,
    'box.archived': PackageIcon, 'box.unarchived': BoxIcon, 'box.deleted': TrashIcon,
    'box_gift.received': GiftIcon, 'box_gift.sent': GiftIcon,
    'gift.sent': GiftIcon, 'gift.received': GiftIcon,
    'gift.sent_undone': RefreshIcon, 'gift.received_undone': RefreshIcon,
  };
  const Icon = icons[type as keyof typeof icons] || ClockIcon;
  return <Icon />;
}
